module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mini-calculator-page', [_c('div', {
    staticClass: "flex-grid--vertical",
    attrs: {
      "slot": "summary-panel"
    },
    slot: "summary-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results a-form-inputs u-full-width u-margin-auto"
  }, [_c('mini-calculator-header', {
    attrs: {
      "title": "Mesothelioma PSLA Calculator",
      "icon": "mesothelioma-psla-calculator"
    }
  }), _vm._v(" "), _c('div', [_c('control', {
    attrs: {
      "for": "date_of_birth",
      "label": "Date of Birth"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:date_of_birth.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "date_of_birth",
      modifiers: {
        "required": true
      }
    }],
    ref: "dateOfBirth",
    on: {
      "input": _vm.handler
    },
    model: {
      value: (_vm.dateOfBirth),
      callback: function($$v) {
        _vm.dateOfBirth = $$v
      },
      expression: "dateOfBirth"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('date_of_birth')
    }
  }, [_vm._v("\n                        The date of birth is required and must be in the format DD/MM/YYYY\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "age_of_person",
      "label": "Age"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ageOfPerson),
      expression: "ageOfPerson",
      modifiers: {
        "number": true
      }
    }],
    ref: "ageOfPerson",
    attrs: {
      "autocomplete": "off",
      "type": "number"
    },
    domProps: {
      "value": (_vm.ageOfPerson)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.ageOfPerson = _vm._n($event.target.value)
      }, _vm.handler],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('age')
    }
  }, [_vm._v("\n                        The age is required\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "duration_of_symptoms",
      "label": "Duration Of Symptoms",
      "before-after": "months"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.durationOfSymptoms),
      expression: "durationOfSymptoms",
      modifiers: {
        "number": true
      }
    }],
    ref: "durationOfSymptoms",
    attrs: {
      "autocomplete": "off",
      "type": "number"
    },
    domProps: {
      "value": (_vm.durationOfSymptoms)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.durationOfSymptoms = _vm._n($event.target.value)
      }, _vm.handler],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('duration_of_symptoms')
    }
  }, [_vm._v("\n                        The duration of symptoms is required\n                    ")])], 1)], 1), _vm._v(" "), _c('h2', {
    staticClass: "u-r-margin-top-40"
  }, [_vm._v("\n                Result\n            ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "result",
      "label": "PSLA Award",
      "before-after": "pound-on-dark"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.pslaAward),
      expression: "pslaAward"
    }],
    attrs: {
      "autocomplete": "off",
      "disabled": "disabled",
      "id": "age_at_death",
      "type": "number",
      "name": "age_at_death"
    },
    domProps: {
      "value": (_vm.pslaAward)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pslaAward = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showResults),
      expression: "showResults"
    }],
    staticClass: "flex-grid--vertical",
    attrs: {
      "slot": "results-panel"
    },
    slot: "results-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results-panel u-full-width u-margin-auto"
  }, [_c('h2', [_vm._v("Explanation")]), _vm._v(" "), _c('p', [_vm._v("\n                Welcome to our Mesothelioma General Damages (PSLA) calculator. The calculator shows estimated common law awards\n                according to 'age' and 'duration of symptoms' — the period between onset of the disease\n                and death (or anticipated date of death).\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                There are two parts to the calculator:\n            ")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("\n                    The first is a Tariff Table designed to give a broad brush indication of possible awards and\n                    is not intended to substitute a detailed review and consideration of actual awards to\n                    properly value any PSLA award. The Tariff Table is based on the 14th Edition of the JC Guidelines.\n                ")]), _vm._v(" "), _c('li', [_vm._v("\n                    The second shows actual PLSA awards which most closely fit the selected age and duration\n                    of symptoms.\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "u-d-flex u-flex-space-between"
  }, [_c('h2', [_vm._v("Tariff Table")]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--smaller",
    on: {
      "click": function($event) {
        return _vm.applyUplift()
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.upliftButton ? 'Add' : 'Remove') + " 10% Uplift\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "a-table--short-no-style"
  }, [(_vm.table && !_vm.loading.table) ? _c('table', {
    staticClass: "a-table a-table--full-width a-table--condensed"
  }, [_c('tr', [_c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Age (Up to)")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": _vm.table[50].length
    }
  }, [_vm._v("\n                            Duration (months)\n                        ")])]), _vm._v(" "), _c('tr', _vm._l((_vm.table[50].length), function(col) {
    return _c('th', [(col === 1) ? _c('span', [_vm._v("0-3")]) : (col === 13) ? _c('span', [_vm._v("37+")]) : _c('span', [_vm._v(_vm._s(col * 3 - 2) + "-" + _vm._s(col * 3))])])
  }), 0), _vm._v(" "), _vm._l((_vm.table), function(tr, age) {
    return _c('tr', [_c('th', [_vm._v(_vm._s(age))]), _vm._v(" "), _vm._l((tr), function(td, index) {
      return _c('td', {
        style: (_vm.getTariffTableTdStyle(index, age))
      }, [_vm._v("\n                            " + _vm._s(_vm.currencyFormat(_vm.uplift ? Math.round(td * 1.1) : td, '£', 0)) + "\n                        ")])
    })], 2)
  })], 2) : _vm._e()]), _vm._v(" "), (_vm.loading.table) ? _c('div', [_c('div', {
    class: {
      'a-loader--table': _vm.loading.table
    }
  })]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "c-gd-psla-calculator__disclaimer"
  }, [_vm._v("Data is up-to-date as of " + _vm._s(_vm.currentRpi) + " *")]), _vm._v(" "), _c('h2', [_vm._v("Awards")]), _vm._v(" "), _vm._l((_vm.filteredAwards), function(award) {
    return (!_vm.loading.awards) ? _c('psla-award', {
      attrs: {
        "award": award,
        "showButtons": false
      }
    }) : _vm._e()
  }), _vm._v(" "), (_vm.loading.awards) ? _c('div', [_c('div', {
    class: {
      'a-loader--table': _vm.loading.awards
    }
  })]) : _vm._e()], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dcd59974!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mini-calculators/calculators/mesoCalculator.vue
// module id = 1819
// module chunks = 0